import {Injectable} from '@angular/core';
import {dateTimeFormatter, FormatterType, StringUtils} from 'ac-infra';
import * as _ from 'lodash';
import {AcFilterType, FilterTypeSelectionFields} from '../modals/ac-filter-type.class';
import {MetadataService} from '../../../../metadata/metadata.service';
import {AcFilterItemComponent} from '../ac-filter-item/ac-filter-item.component';

@Injectable({providedIn: 'root'})
export class FilterItemService {

    getTextFromSelectionFields = (selectionFields: FilterTypeSelectionFields, fieldName, entity) => {
        const mapper = selectionFields[fieldName].listName ? MetadataService.getType(selectionFields[fieldName].listName) : (selectionFields[fieldName].list || undefined);
        if (mapper) {
            const prefixList = selectionFields[fieldName].prefixList;
            const prefix = prefixList ? prefixList[mapper[entity].type] : '';
            return prefix ? prefix + ': ' + mapper[entity].viewName : (mapper[entity]?.viewName || entity);
        }
    };

    getItemTitle = async (acFilterType: AcFilterType, fieldName, filterValue) => {
        if (acFilterType.getTitleByField) {
            const customText = await acFilterType.getTitleByField(fieldName, {[fieldName]: filterValue});
            if (customText || customText === '') {
                return customText;
            }
        }

        let valueToDisplay = filterValue;
        if (filterValue?.items) {
            valueToDisplay = filterValue.items;
        }

        if (Array.isArray(valueToDisplay) && valueToDisplay.length > 0) {
            if (acFilterType.checkboxGroups) {
                return this.mapperForCheckboxGroupsKeyToText(valueToDisplay, acFilterType, fieldName).join(', ');
            }

            return valueToDisplay.length === 1 ? this.getTitleWithSingleValue(acFilterType, valueToDisplay, fieldName) : this.getTitleWithMultipleValues(acFilterType, filterValue, fieldName);
        } else if (_.isString(valueToDisplay)) {
            return this.getFilterTextFromString(valueToDisplay, fieldName);
        }

        return '';
    };

    getFilterTextFromString = (value, headLine) => {
        if (headLine === 'from' || headLine === 'to') {
            return dateTimeFormatter(value, FormatterType.dateAndTimeNoSec);
        }

        return value;
    };

    getTitleWithSingleValue = (acFilterType, filterValue, fieldName) => {
        const entity = filterValue[0];
        let entityName: string;

        if (acFilterType.selectionFields) {// ac-select filters -> more filters
            entityName = this.getTextFromSelectionFields(acFilterType.selectionFields, fieldName, entity);
        } else if (entity.viewName || entity.name || entity.text) {// by property
            entityName = entity.viewName || entity.name || (entity.prefix ? entity.prefix + ': ' + entity.text : entity.text);
        }

        return entityName || (_.isString(entity) && entity) || '';
    };

    getFilterHeadLine = (key, acFilterType, filterValue?) => {
        let headLine = (acFilterType.fieldNameMapper && acFilterType.fieldNameMapper[key]) ? acFilterType.fieldNameMapper[key] : key;
        headLine = StringUtils.toTitleCase(headLine, {onlyLeadWord: false});

        if (filterValue?.comparison === '!~') {
            headLine = `${headLine} (not containing)`;
        }

        return headLine;
    };

    getTitleWithMultipleValues = (acFilterType, filterValue, fieldName) => {
        const actualValue = filterValue?.items || filterValue;
        const headLine = this.getFilterHeadLine(fieldName, acFilterType, filterValue);
        const length = Array.isArray(actualValue) ? actualValue.length : 0;

        return length + ' ' + headLine;
    };
    mapperForCheckboxGroupsKeyToText = (array, acFilterType, headLine) => {
        const arrayAfterMapping = [];

        array.forEach((item) => {
            arrayAfterMapping.push(acFilterType.checkboxGroups[headLine].map[item]);
        });

        return arrayAfterMapping;
    };
}
